<script lang="ts" setup>
import { usePreviewImg } from "@/use/common";
import { useI18n } from "vue-i18n";
import { useGalGameEditor } from "@/stores/galGameEditor";
import { computed } from "vue";

const props = defineProps<{
  dialog: GalGameDialog;
  index?: number;
}>();

const { t } = useI18n();
const store = useGalGameEditor();

const getPreviewUrl = (dialog: GalGameDialog) => {
  if (dialog.previewMedia) {
    return usePreviewImg(dialog.previewMedia.url);
  }
  if (dialog.sceneMedia) {
    return usePreviewImg(dialog.sceneMedia.url);
  }
  return "";
};
const character = computed(
  () => store.characterIdMap[props.dialog.characterId]
);
</script>
<template>
  <div
    class="w-32 md:w-44 flex flex-col shrink-0 relative bg-base-200 border-2 rounded box-border overflow-hidden shadow-md"
  >
    <div
      v-if="index !== undefined"
      class="absolute top-2 left-2 rounded-full aspect-[1/1] badge badge-neutral badge-xs p-2"
    >
      {{ index + 1 }}
    </div>
    <!--  图片区域  -->
    <div class="aspect-[16/9] w-full bg-base-300 overflow-hidden">
      <img
        v-if="getPreviewUrl(dialog)"
        :src="getPreviewUrl(dialog)"
        alt="preview"
        class="w-full h-full object-cover"
      />
      <span
        v-else
        class="w-full h-full flex justify-center items-center text-xs"
      >
        {{ t("game.noImage") }}
      </span>
    </div>
    <!--  dialog - 角色:文本  -->
    <div class="van-ellipsis p-2 w-full text-xs md:text-md">
      <span v-if="character?.name">{{ character.name }}: </span>
      <span :class="{ 'text-base-content/50': !dialog.text }">{{
        dialog.text ? dialog.text : t("game.notSet")
      }}</span>
    </div>
  </div>
</template>
